/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {Col, FormGroup, FormLabel, Row} from "react-bootstrap";
import {UserWithDateTimeFieldViewer} from "../../../Models/Core/FieldViewers/UserWithDateTimeFieldViewer";
import {ContextNodeWithDateTimeFieldViewer} from "../../../Models/Core/FieldViewers/ContextNodeWithDateTimeFieldViewer";
import {
	SpeciesRequestSpeciesListsFieldViewer
} from "../../../Models/Core/FieldViewers/SpeciesRequestSpeciesListsViewerComponent";
import {SpeciesRequestSourceFieldViewer} from "../../../Models/Core/SpeciesFieldComponents";
import {HelpIcon} from "../HelpIcon";

export const SpeciesRequestSummary = (props) => {
	
	const {species} = props;
	const {SpeciesRequest: speciesRequest} = species;
	
	return <div  className="sb-summary">
		<Row xs={12}>
			<Col xs={6} key={1}>
				{[
					<FormGroup key={1}>
						<FormLabel>Requested By</FormLabel>
						<UserWithDateTimeFieldViewer userId={speciesRequest?.requestedByUserId} date={speciesRequest?.requested} />
					</FormGroup>,
					
					<FormGroup key={2}>
						<FormLabel>Species Observed At</FormLabel>
						<ContextNodeWithDateTimeFieldViewer contextNodeId={speciesRequest?.observedProjectContextNodeId} date={speciesRequest?.observedDate} />
					</FormGroup>,
	
					<FormGroup key={3}>
						<FormLabel>Custom Lists where it is applicable</FormLabel>
						<SpeciesRequestSpeciesListsFieldViewer speciesRequestSpeciesLists={speciesRequest?.SpeciesRequestSpeciesList} />
					</FormGroup>,
				]}
			</Col>
			<Col xs={6} key={2}>
				{[
					<FormGroup key={1}>
						<FormLabel>Source <HelpIcon>The application or integration from where this Species Request originated.</HelpIcon></FormLabel>
						<SpeciesRequestSourceFieldViewer Value={speciesRequest?.speciesRequestSourceId} />
					</FormGroup>,
					
					<FormGroup key={2}>
						<FormLabel>Requester Notes</FormLabel>
						<div>{speciesRequest?.requesterNotes ?? '(None Specified)'}</div>
					</FormGroup>,
				]}
			</Col>
		</Row>
	</div>;
}